import { create } from 'zustand'

// The current page's prize-draw context as given to its Layout header, so UI mounted
// outside the page (the mobile bottom nav's account drawer) matches the header.
// `undefined` when the page has no Layout - consumers fall back to the pathname.
interface PrizeDrawContextState {
  isPrizeDrawContext: boolean | undefined
  setIsPrizeDrawContext: (isPrizeDrawContext: boolean | undefined) => void
}

export const usePrizeDrawContextStore = create<PrizeDrawContextState>((set) => ({
  isPrizeDrawContext: undefined,
  setIsPrizeDrawContext: (isPrizeDrawContext) => set({ isPrizeDrawContext }),
}))
